import React from 'react';
import Slider from 'react-slick';
import { useDiscounts } from '../hooks/discounts';
import { useTranslation } from 'react-i18next';
import { useMoney } from '../stores/currenciesStore';

const DiscountOne = () => {
    const { t } = useTranslation();
    const { discounts, loading } = useDiscounts();
    const { money } = useMoney();

    function SampleNextArrow(props) {
        const { className, onClick } = props;
        return (
            <button
                type="button" onClick={onClick}
                className={` ${className} slick-next tw-right-2 tw-z-10 slick-arrow flex-center rounded-circle bg-main-600 hover-bg-tertiary-600 text-white text-xl transition-1`}
            >
                <i className="ph ph-caret-right" />
            </button>
        );
    }
  
    function SamplePrevArrow(props) {
        const { className, onClick } = props;

        return (
            <button
                type="button"
                onClick={onClick}
                className={`${className} slick-prev tw-left-2 tw-z-10 slick-arrow flex-center rounded-circle bg-main-600 hover-bg-tertiary-600 text-white text-xl transition-1`}
            >
                <i className="ph ph-caret-left" />
            </button>
        );
    }

    const settings = {
        dots: true,
        arrows: false,
        infinite: false,
        speed: 1000,
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 0,
        autoplay: true,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
        appendDots: dots => (
            <div style={{ 
                bottom: "-40px",
                padding: "10px 0",
                display: "flex",
                justifyContent: "center",
                width: "100%"
            }}>
                <ul style={{ 
                    margin: "0", 
                    padding: "0",
                    display: "flex", 
                    flexDirection: "row",
                    justifyContent: "center",
                    listStyleType: "none"
                }}> 
                    {dots} 
                </ul>
            </div>
        ),
        customPaging: i => (
            <div style={{
                width: "10px",
                height: "10px",
                background: "#ddd",
                borderRadius: "50%",
                margin: "0 5px",
                display: "inline-block"
            }}></div>
        ),
        dotsClass: "slick-dots custom-dot-list",
    };

    // Function to get badge based on applies_to field
    const getDiscountTypeBadge = (appliesTo) => {
        switch(appliesTo) {
            case 'cart':
                return (
                    <span className="top-0 px-3 py-2 m-3 badge bg-main-600 position-absolute end-0 rounded-pill">
                        {t('discount.cart_discount', 'Descuento del Carrito')}
                    </span>
                );
            case 'product':
                return (
                    <span className="top-0 px-3 py-2 m-3 badge bg-tertiary-600 position-absolute end-0 rounded-pill">
                        {t('discount.product_discount', 'Product Discount')}
                    </span>
                );
            default:
                return (
                    <span className="top-0 px-3 py-2 m-3 bg-gray-500 badge position-absolute end-0 rounded-pill">
                        {t('discount.general_discount', 'Discount')}
                    </span>
                );
        }
    };

    // Filter active discounts
    const activeDiscounts = discounts.filter(discount => discount.is_active);

    if (loading) {
        return (
            <section className="tw-pt-8 xl:tw-pt-16 discount">
                <div className="container container-lg">
                    <div className="text-center">
                        <div className="spinner-border text-main-600" role="status">
                            <span className="visually-hidden">{t('common.loading')}</span>
                        </div>
                    </div>
                </div>
            </section>
        );
    }

    if (!activeDiscounts || activeDiscounts.length === 0) {
        return null; // Don't show section if no active discounts
    }

    return (
        <>
            <style>
                {`
                .custom-dot-list .slick-active div {
                    background-color: #FF9800 !important;
                }
                .custom-dot-list {
                    display: flex !important;
                    justify-content: center !important;
                    flex-direction: row !important;
                }
                `}
            </style>
            <section className="tw-pt-8 xl:tw-pt-16 discount">
                <div className="container container-lg">
                    <Slider {...settings}>
                        {activeDiscounts.map((discount, index) => (
                            <div key={discount.id || index} className="px-2">
                                <div className="overflow-hidden !tw-bg-transparent discount-item rounded-16 position-relative z-1 h-100 d-flex flex-column align-items-start justify-content-center">
                                    {getDiscountTypeBadge(discount.applies_to)}
                                    <img
                                        src={`assets/images/bg/discount-bg1.jpg`}
                                        alt=""
                                        className="position-absolute inset-block-start-0 inset-inline-start-0 w-100 h-100 z-n1"
                                    />
                                    <div className="gap-20 w-100 flex-between">
                                        <div className="discount-item__content">
                                            <span className="mb-20 fw-semibold text-tertiary-600">
                                                {discount.name}
                                            </span>
                                            <h6 className="mb-20">
                                                {discount.description}
                                            </h6>
                                            {/* {(discount.starts_at || discount.ends_at) && (
                                                <p className="text-gray-500">
                                                    {discount.starts_at && `${t('discount.valid_from', 'Valid from')} ${discount.starts_at}`}
                                                    {discount.starts_at && discount.ends_at && ' - '}
                                                    {discount.ends_at && `${t('discount.valid_until', 'Valid until')} ${discount.ends_at}`}
                                                </p>
                                            )} */}
                                            {discount.minimum_order_amount > 0 && (
                                                <p className="text-info">
                                                    {t('discount.min_order', 'Minimum order')}: {money(discount.minimum_order_amount)}
                                                </p>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </Slider>
                </div>
            </section>
        </>
    );
};

export default DiscountOne;